import React, { useCallback } from "react";
import cn from "classnames";

import styles from "./style.module.scss";
import NewAddressFields from "../NewAddressFields";
import { LocalisedText } from "../../i18n";
import { MessageID } from "../../i18n/types";

interface CustomAddressOptionProps {
  isSelected: boolean;
  country: string;
  address1: string;
  address2: string;
  saveForFutureUse: boolean;
  setCountry: (value: string) => void;
  setAddress1: (value: string) => void;
  setAddress2: (value: string) => void;
  setSaveForFutureUse: (value: boolean) => void;
  isDisabled?: boolean;
  onSelect: () => void;
  checkboxDescriptionId: MessageID;
  titleId: MessageID;
}

const CustomAddressOption: React.FC<CustomAddressOptionProps> = (
  props: CustomAddressOptionProps
) => {
  const {
    titleId,
    address1,
    address2,
    country,
    saveForFutureUse,
    setCountry,
    setAddress1,
    setAddress2,
    setSaveForFutureUse,
    isSelected,
    onSelect,
    isDisabled,
    checkboxDescriptionId,
  } = props;

  const handleOnSelected = useCallback(() => {
    if (isDisabled) return;
    onSelect();
  }, [onSelect, isDisabled]);

  return (
    <div className={styles.option}>
      <div className={styles.selection} onClick={handleOnSelected}>
        <div
          className={cn(styles.selectionBox, {
            [styles.selected]: isSelected,
          })}
        >
          <div className={styles.selectedDot} />
        </div>
        <div className={styles.title}>
          <LocalisedText id={titleId} />
        </div>
      </div>
      <div>
        {isSelected && (
          <NewAddressFields
            country={country}
            address1={address1}
            address2={address2}
            saveForFutureUse={saveForFutureUse}
            setCountry={setCountry}
            setAddress1={setAddress1}
            setAddress2={setAddress2}
            setSaveForFutureUse={setSaveForFutureUse}
            isDisabled={isDisabled}
            checkboxDescriptionId={checkboxDescriptionId}
          />
        )}
      </div>
    </div>
  );
};

export default CustomAddressOption;
